(() => {
  const customerId = window.wishlistData?.customerId || 0;
  const STORAGE_KEY = `wishlist_${customerId}`;

  const getItems = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  };

  const setItems = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  };

  const hasItem = (variantId) =>
    getItems().some((item) => String(item.variantId) === String(variantId));

  const addItem = (variantId, productHandle) => {
    const items = getItems();
    if (!hasItem(variantId)) {
      items.push({ variantId: String(variantId), productHandle });
      setItems(items);
    }
  };

  const removeItem = (variantId) => {
    setItems(getItems().filter((item) => String(item.variantId) !== String(variantId)));
  };

  const trackEvent = (eventName, variantId, productHandle) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    const payload = {
      currency,
      items: [{ item_id: String(variantId), item_name: productHandle }],
    };
    if (typeof gtag === 'function') {
      gtag('event', eventName, payload);
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ecommerce: payload });
    }
  };

  const toggleItem = (variantId, productHandle) => {
    if (hasItem(variantId)) {
      removeItem(variantId);
      trackEvent('remove_from_wishlist', variantId, productHandle);
      return false;
    }
    addItem(variantId, productHandle);
    trackEvent('add_to_wishlist', variantId, productHandle);
    return true;
  };

  const updateCounter = () => {
    const count = getItems().length;
    document.querySelectorAll('[data-wishlist-counter]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  };

  const updateButtons = () => {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const active = hasItem(btn.dataset.variantId);
      btn.classList.toggle('wishlist-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  };

  const updateUI = () => {
    updateCounter();
    updateButtons();
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggleItem(btn.dataset.variantId, btn.dataset.productHandle);
    updateUI();
  });

  document.addEventListener('DOMContentLoaded', updateUI);

  window.Wishlist = { getItems, hasItem, addItem, removeItem, toggleItem, updateUI };
})();
